import { formatEnumError as E } from "../../core/recipes/diagnostics.js";
import { Sequence as m, SequenceState as b } from "./components.js";
import { createShaker as k, sequenceRegistry as q, createTween as N, EasingNames as S } from "./utils.js";
const p = Object.keys(S);
function l(t, e) {
  if (t && !p.includes(t))
    throw new Error(E(e, "easing", t, p));
}
function f(t) {
  return typeof t == "number" ? t : typeof t == "string" ? parseFloat(t) || 0 : typeof t == "boolean" && t ? 1 : 0;
}
function g(t) {
  if (typeof t == "number") return t;
  if (typeof t == "object" && t !== null) {
    const e = t;
    if ("x" in e || "y" in e || "z" in e)
      return [e.x || 0, e.y || 0, e.z || 0];
  }
  return f(t);
}
const C = ({ element: t, state: e, context: s }) => {
  if (t.tagName !== "tween")
    return;
  const n = t.attributes.target;
  if (!n)
    throw new Error(
      `[Tween] Missing required attribute "target".
  Tweens must specify which entity to animate using the target attribute.
  Example: <tween target="my-cube" attr="transform.pos-x" to="10"></tween>`
    );
  const o = s.getEntityByName(n);
  if (o === null)
    throw new Error(
      `[Tween] Could not find entity with name "${n}".
  Make sure the target entity has a name attribute that matches.
  Example: <entity name="my-cube" transform=""></entity>`
    );
  const i = t.attributes.attr;
  if (!i)
    throw new Error(
      `[Tween] Missing required attribute "attr".
  Tweens must specify which property to animate.
  Example: <tween target="my-cube" attr="transform.pos-x" to="10"></tween>`
    );
  const a = t.attributes.to;
  if (a == null)
    throw new Error(
      `[Tween] Missing required attribute "to".
  Tweens must specify the target value.
  Example: <tween target="my-cube" attr="transform.pos-x" to="10"></tween>`
    );
  const r = t.attributes.easing;
  l(r, "tween");
  const u = {
    from: t.attributes.from !== void 0 ? g(t.attributes.from) : void 0,
    to: g(a),
    duration: f(t.attributes.duration || 1),
    easing: r
  };
  if (!N(e, o, i, u))
    throw new Error(`[Tween] Could not resolve tween target property: ${i}`);
}, I = ({ element: t, state: e, context: s }) => {
  if (t.tagName !== "sequence") return;
  const n = e.createEntity();
  e.addComponent(n, m);
  const o = t.attributes.name, i = t.attributes.autoplay;
  o && s.setName(o, n);
  const a = [];
  for (const r of t.children)
    if (r.tagName === "tween") {
      const u = r.attributes.target;
      if (!u)
        throw new Error('[Sequence] Tween missing "target" attribute');
      const c = s.getEntityByName(u);
      if (c === null)
        throw new Error(`[Sequence] Target "${u}" not found`);
      const w = r.attributes.attr;
      if (!w)
        throw new Error('[Sequence] Tween missing "attr" attribute');
      const y = r.attributes.to;
      if (y == null)
        throw new Error('[Sequence] Tween missing "to" attribute');
      const h = r.attributes.easing;
      l(h, "sequence > tween"), a.push({
        type: "tween",
        target: c,
        attr: w,
        from: r.attributes.from !== void 0 ? g(r.attributes.from) : void 0,
        to: g(y),
        duration: f(r.attributes.duration || 1),
        easing: h
      });
    } else r.tagName === "pause" && a.push({
      type: "pause",
      duration: f(r.attributes.duration || 0)
    });
  q.set(n, a), m.state[n] = i ? b.Playing : b.Idle, m.currentIndex[n] = 0, m.itemCount[n] = a.length, m.pauseRemaining[n] = 0;
}, d = ["additive", "multiplicative"];
function T(t, e) {
  if (t && !d.includes(t))
    throw new Error(E(e, "mode", t, d));
}
const $ = ({ element: t, state: e, context: s }) => {
  if (t.tagName !== "shaker") return;
  const n = t.attributes.target;
  if (!n)
    throw new Error(
      `[Shaker] Missing required attribute "target".
  Example: <shaker target="my-cube" attr="transform.pos-y" value="0.5"></shaker>`
    );
  const o = s.getEntityByName(n);
  if (o === null)
    throw new Error(
      `[Shaker] Could not find entity with name "${n}".
  Make sure the target entity has a name attribute.`
    );
  const i = t.attributes.attr;
  if (!i)
    throw new Error(
      `[Shaker] Missing required attribute "attr".
  Example: <shaker target="my-cube" attr="transform.pos-y" value="0.5"></shaker>`
    );
  const a = t.attributes.value;
  if (a == null)
    throw new Error(
      `[Shaker] Missing required attribute "value".
  Example: <shaker target="my-cube" attr="transform.pos-y" value="0.5"></shaker>`
    );
  const r = t.attributes.mode;
  T(r, "shaker");
  const u = {
    value: f(a),
    intensity: f(t.attributes.intensity ?? 1),
    mode: r
  }, c = k(e, o, i, u);
  if (!c)
    throw new Error(`[Shaker] Could not resolve target property: ${i}`);
  const w = t.attributes.name;
  w && s.setName(w, c);
};
export {
  I as sequenceParser,
  $ as shakerParser,
  C as tweenParser
};
//# sourceMappingURL=parser.js.map
